import { HttpErrorResponse } from '@angular/common/http';
import { Component, Injector, OnInit } from '@angular/core';
import { AttachmentsBaseComponent } from '../attachment-base/attachment-base.component';
import { BaseComponent } from '../base/base.component';
import { PublicationHistoryItem } from '../services/publication-history/PagedPublicationHistoryList';
import { RecentDecisionService } from '../services/recent-decision/recent-decision.service';
import { SubmittalService } from '../services/submittal/submittal.service';

@Component({
  selector: 'app-recent-decisions',
  templateUrl: './recent-decisions.component.html',
  styleUrls: ['./recent-decisions.component.css']
})
export class RecentDecisionsComponent extends BaseComponent implements OnInit {
  public tabIndex = new Array(true, false, false, false, false, false, false);
  private recentDecisionService: RecentDecisionService;
  recentDecisions: PublicationHistoryItem[] = [];
  dateFrom: Date;
  dateTo: Date;
  private submittalService: SubmittalService;
  attachmentsBaseComponent: AttachmentsBaseComponent;

  constructor(public _injector: Injector) {
    super(_injector);
    this.recentDecisionService = this._injector.get(RecentDecisionService);
    this.submittalService = this._injector.get(SubmittalService);
    this.attachmentsBaseComponent = this._injector.get(AttachmentsBaseComponent);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.LoadENFCert();
  }

  LoadENFCert() {
    this.LoadCert(BaseComponent.ConstENF);
  }

  LoadEIRCert() {
    this.LoadCert(BaseComponent.ConstEIR);
  }

  LoadNPCCert() {
    this.LoadCert(BaseComponent.ConstNPC);
  }

  LoadRODCert() {
    this.LoadCert(BaseComponent.ConstROD);
  }

  LoadSRPCert() {
    this.LoadCert(BaseComponent.ConstSRP);
  }

  LoadPBNCert() {
    this.LoadCert(BaseComponent.ConstPBN);
  }

  LoadAOCert() {
    this.LoadCert(BaseComponent.ConstAO)
  }

  LoadCert(certificateType: string) {
    this.showProgress();
    this.recentDecisionService.GetRecentDecisionList(certificateType).subscribe(recentDecisions => {
      this.recentDecisions = recentDecisions.list;
      this.dateFrom = recentDecisions.initialDate;
      this.dateTo = recentDecisions.endDate;
      this.hideProgress();
    }, (error: HttpErrorResponse) => {
      this.hideProgress();
      this.ShowErrorMessage("Try Again or Contact support.", "Error retrieving Recent decision list", () =>
        this.hideProgress()
      );
    });
  }

  ValidateCommentsDue(publicationHistoryItem: PublicationHistoryItem): string {
    var returnValue = "";
    if (publicationHistoryItem.withdrawn == true) {
      returnValue = "Withdrawn";
    } else returnValue = this.IfCommentDueIsNullReturnNA(publicationHistoryItem);
    return returnValue;
  }

  GoToSubmittal(item: any) {
    this.submittalService.setEeaNumber(item.eeaNumber);
    this.submittalService.setProjectName(item.projectName);
    
    this.router.navigateByUrl(`/submittal/${item.submittalId}`);
  }

  private IfCommentDueIsNullReturnNA(publicationHistoryItem: PublicationHistoryItem) {
    var returnValue = "";
    if (this.IsNullOrUndefined(publicationHistoryItem.commentsDue)) {
      returnValue = "NA";
    } else {
      var { DateTime } = require('luxon');
      var dueDate = DateTime.fromISO(publicationHistoryItem.commentsDue);
      returnValue = dueDate.toFormat('MM/dd/yyyy');
    }
    return returnValue;
  }

  OpenFirstAttachment(item: any){
    this.attachmentsBaseComponent.OpenFirstSubmittalAttachment(item.submittalId);
  }
}
